import { render, staticRenderFns } from "./kv-chip.vue?vue&type=template&id=398c40bd"
import script from "./kv-chip.vue?vue&type=script&lang=js"
export * from "./kv-chip.vue?vue&type=script&lang=js"
import style0 from "./kv-chip.vue?vue&type=style&index=0&id=398c40bd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports